export const tr = {
    'empty-gallery-message': 'Uygun sonuç bulunamadı',
    'preview-error': 'Önizleme verileri yüklenirken hata oluştu. Lütfen, az sonra tekrar deneyin.',
    'remove-item-confirmation': '"{name}" dosyasını silmek istediğinizden emin misiniz?'
};
